import {ReactElement} from "react";
import {PayrollDefaultLevel} from "../../../../__generated__/generated_types";
import DefaultsForm from "./DefaultsForm";
import DefaultsFormWithInitialData from "./DefaultsFormWithInitialData";
import * as styles from "./PayrollDefaults.module.scss";

interface ClientDefaultsWrapperProps {
    positionIds: string[];
}

export default function ClientDefaultsWrapper(props: ClientDefaultsWrapperProps): ReactElement {
    const {positionIds} = props;

    if(positionIds.length === 0) {
        return <div className={styles.positionSelectorMessage}>Select a position to configure defaults.</div>;
    }

    const selectedPositionId = positionIds[0];

    if(positionIds.length === 1 && selectedPositionId) {
        return (
            <DefaultsFormWithInitialData
                positionId={selectedPositionId}
                defaultLevel={PayrollDefaultLevel.Client}
            />
        );
    }

    return (
        <DefaultsForm
            positionIds={positionIds}
            defaultLevel={PayrollDefaultLevel.Client}
            showResetControls={false}
        />
    );
}
